"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsomorphicLayoutEffect = void 0;

var _react = _interopRequireDefault(require("react"));

var _isServerSide = require("./isServerSide");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Isomorphic React effect hook works on the both client and server.
 *
 * Motivation:
 * There are cases where React hook `useLayoutEffect` makes more sense if we
 * want to perform DOM operations synchronously before browser paint.
 * However, React warns when used this hook with SSR components. Hence,
 * suppressing the warning by switching the hook between SSR and CSR.
 *
 */
var useIsomorphicLayoutEffect = (0, _isServerSide.isServerSide)() ? _react["default"].useEffect : _react["default"].useLayoutEffect;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;